import type { SVGProps } from 'react';
const SvgCameraRoll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#camera_roll_svg__a)">
      <path
        fill="currentColor"
        d="M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8Zm-2 13h-2v-2h2v2Zm0-9h-2V7h2v2Zm4 9h-2v-2h2v2Zm0-9h-2V7h2v2Zm4 9h-2v-2h2v2Zm0-9h-2V7h2v2Z"
      />
    </g>
    <defs>
      <clipPath id="camera_roll_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCameraRoll;
